import React from 'react';

// ZoomContext is used to allow any child elements of the workspace
// (however nested) to know what amount of zooming they're subject to.
// This is needed for things like correct drag-n-drop operations within
// the zoomed content area.
const ZoomContext = React.createContext(1);

export default ZoomContext;
